let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dFTkb")).then(() => parcelRequire('a7oHn'));